<template>
  <router-view v-if="showrouter" />
  <div
    v-else
    style="width:100%;height:100%;     padding: 1% 3% 0 2% ;position: relative ;  text-align: left"
  >
    <div class="addExamination">
      <div class="nameDiv">
        <div>
          <span>{{
            this.$route.query.examinationType == '0'
              ? $t('translateText.newwork.ksmc')
              : $t('translateText.newwork.zymc')
          }}</span>
          <input
            type="text"
            :placeholder="$t('translateText.newwork.srnr')"
            v-model="topic"
          />
        </div>
        <div class="searchh">
          <!-- <input type="text" placeholder="输入内容"/> -->
          <search
            :placeholder="$t('translateText.newwork.tmmc')"
            @search="onSearch"
          />
        </div>
      </div>
      <!-- <div>111</div> -->
      <div class="questionTypeDiv">
        <span>{{ $t('translateText.newwork.tmlx') }}：</span>
        <a-radio-group v-model="questionTypeValue">
          <a-radio @click="selecttype" :value="1">{{
            $t('translateText.swi.dxt')
          }}</a-radio>
          <a-radio @click="selecttype" :value="2">{{
            $t('translateText.swi.ddxt')
          }}</a-radio>
          <a-radio @click="selecttype" :value="3">{{
            $t('translateText.swi.pdt')
          }}</a-radio>
          <a-radio @click="selecttype" :value="4">{{
            $t('translateText.swi.tkt')
          }}</a-radio>
          <a-radio @click="selecttype" :value="5">{{
            $t('translateText.swi.jdt')
          }}</a-radio>
          <a-radio @click="selecttype" :value="6">{{
            $t('translateText.swi.tjbz')
          }}</a-radio>
          <a-radio @click="selecttype" :value="7">{{
            $t('translateText.swi.jdbz')
          }}</a-radio>
        </a-radio-group>
      </div>
      <div class="questionLevelDiv">
        <span>{{ $t('translateText.newwork.ndxs') }}：</span>
        <a-radio-group v-model="questionLevelValue">
          <a-radio @click="selectlevel" :value="1">{{
            $t('translateText.newwork.jd')
          }}</a-radio>
          <a-radio @click="selectlevel" :value="2">{{
            $t('translateText.newwork.yb')
          }}</a-radio>
          <a-radio @click="selectlevel" :value="3">{{
            $t('translateText.newwork.kb')
          }}</a-radio>
        </a-radio-group>
      </div>
      <div style="    position: absolute;top: 100px;right:0">
        <one-button @click="preview">{{$t('translateText.newwork.yl')}}</one-button>
        <one-button v-on:translatecolor="addquestion">{{
          $t('translateText.newwork.xjst')
        }}</one-button>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 1">
        <div
          v-for="question in questionList"
          :key="question.iQuestionId"
          v-show="questionList.length != 0"
        >
          <single
            :questionInfo="question"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
          ></single>
        </div>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 2">
        <multiple
          v-for="question in questionList"
          v-show="questionList.length != 0"
          :questionInfo="question"
          :key="question.iQuestionId"
          :correctAnswerShow="false"
          v-on:allCheck="allCheck"
          @update="updatescore"
        ></multiple>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 3">
        <judgment
          v-for="question in questionList"
          v-show="questionList.length != 0"
          :questionInfo="question"
          :key="question.iQuestionId"
          :correctAnswerShow="false"
          v-on:allCheck="allCheck"
          @update="updatescore"
        ></judgment>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 4">
        <fillBlank
          v-for="question in questionList"
          v-show="questionList.length != 0"
          :questionInfo="question"
          :key="question.iQuestionId"
          :correctAnswerShow="false"
          v-on:allCheck="allCheck"
          @update="updatescore"
        ></fillBlank>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 5">
        <shortAnswer
          v-for="question in questionList"
          v-show="questionList.length != 0"
          :questionInfo="question"
          :key="question.iQuestionId"
          :correctAnswerShow="false"
          v-on:allCheck="allCheck"
          @update="updatescore"
        ></shortAnswer>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 6">
        <experiment
          v-for="question in questionList"
          v-show="questionList.length != 0"
          :questionInfo="question"
          :key="question.iQuestionId"
          :correctAnswerShow="false"
          v-on:allCheck="allCheck"
          @update="updatescore"
        ></experiment>
      </div>
      <div class="questionListDiv" v-if="questionTypeValue == 7">
        <experiment
          v-for="question in questionList"
          v-show="questionList.length != 0"
          :questionInfo="question"
          :key="question.iQuestionId"
          :correctAnswerShow="false"
          v-on:allCheck="allCheck"
          @update="updatescore"
        ></experiment>
      </div>
      <div v-if="this.questionList.length == 0">
        <img src="@/assets/imgs/zanwusj.png" class="notdata" />
        <p class="notdatas">{{ $t('translateText.noData') }}</p>
      </div>
      <div class="btnDiv">
        <one-button v-on:translatecolor="back">{{
          $t('translateText.swi.back')
        }}</one-button>
        <one-button
          v-if="
            this.$route.path == '/courseContent/Task/Choosework' ||
              this.$route.path == '/courseContent/Exam/Choosework'
          "
          @click="savework"
          >{{ $t('translateText.newwork.xyb') }}</one-button
        >
        <a-modal
          :visible="selectUserDiv"
          :footer="null"
          width="680px"
          @cancel="handleCancel"
        >
          <div>
            <p class="addHomeWorkDivTitle">
              {{ $t('translateText.newwork.fbdx') }}
            </p>
            <selectUser
              ref="selectuser"
              v-show="selectUserDiv"
              :ClassListColumns="ClassListColumns"
              :ClassList="ClassList"
              :ShowClass="true"
              :UserListColumns="UserListColumns"
              :UserList="UserList"
              v-on:getExaminationRelease="getExaminationRelease"
              v-on:getReceiveList="getReceiveList"
            ></selectUser>
            <div class="addHomeWorkDivFooter">
              <button @click="cancelButton">
                {{ $t('translateText.newwork.qx') }}
              </button>
              <button @click="okButton" class="okButton">
                {{ $t('translateText.newwork.fb') }}
              </button>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>
const moment = require('moment')
import search from '@/components/search' //搜索组件
import selectUser from '@/components/Table/SelectUser' //选择发布用户
import single from '@/components/Question/Single' //单选题
import multiple from '@/components/Question/Multiple' //多选题
import judgment from '@/components/Question/Judgment' //判断题
import fillBlank from '@/components/Question/FillBlank' //填空题
import shortAnswer from '@/components/Question/ShortAnswer' //简答题
import experiment from '@/components/Question/Experiment' //简答题
import {
  getQuestions,
  updateExamination,
  updateExaminationRelease,
  getExaminationReceiveList,
} from '@/utils/api'
export default {
  data() {
    return {
      itiScore: '',
      questionInfo: '',
      grade: 0,
      examinationinfo: [],
      topic: '',
      userinfo: {},
      courseid: '',
      questionTypeValue: 1,
      questionLevelValue: 1,
      issueTypeValue: 1,
      questionList: [],
      selectUserDiv: false,
      selectedtopic: [], //选中的题目
      // selectQuestion:[],//选中的题目
      primary: [], //复制一份selectedtopic，用于计算删除的选题
      repetitive: [],
      getcompiledata: [],
      reduced: [],
      ReceiveclassList: [],
      delexamination: [],
      startValue: '',
      starttime: '', //开始时间
      endtime: '', //结束时间
      passingscore: '', //及格分数线
      goodscore: '', //良好分数线
      excellentscore: '', //优秀分数线
      stickup: '', //是否允许粘贴
      outorder: '', //是否乱序
      ReceiveList: [], //接受列表
      viewscore: '', //学生是否可查看成绩
      releaseobj: [], //发放对象
      releasetype: '',
      ClassList: [],
      UserList: [],
      showrouter: false,
    }
  },
  mounted() {
    this.userinfo = this.$store.state.userinfo
    this.courseid = localStorage.getItem('courseId')
    this.questionList = []
    this.getQuestions()
    if (
      this.$route.path == '/courseContent/Task/Choosework' ||
      this.$route.path == '/courseContent/Exam/Choosework'
    ) {
      this.examinationinfo = this.$store.state.examinationinfo
      this.topic = this.examinationinfo.examination.strExaminationName
      this.primary = this.examinationinfo.listQuestion.map((item) => {
        return Object.assign(
          {},
          {
            iExamQuestionId: item.iExamQuestionId,
            question: item.question,
            iScore: item.iScore,
          }
        )
      })
      this.reduced = JSON.parse(JSON.stringify(this.primary))
      this.selectedtopic = this.examinationinfo.listQuestion.map((item) => {
        return Object.assign(
          {},
          {
            iExamQuestionId: item.iExamQuestionId,
            question: item.question,
            iScore: item.iScore,
          }
        )
      })
    }
  },
  methods: {
    //新建试题
    addquestion() {
      if (this.$route.path == '/courseContent/Task/Choosework') {
        this.$router.push('/courseContent/Task/Choosework/NewQuestion')
      }
      if (this.$route.path == '/courseContent/Exam/Choosework') {
        this.$router.push('/courseContent/Exam/Choosework/NewQuestion')
      }
      this.showrouter = true
      this.$store.commit('updataeffect', 'add')
    },
    //更新分数
    updatescore(val) {
      this.selectedtopic = this.selectedtopic.map((item) =>
        item.question.iQuestionId === val.question.iQuestionId ? val : item
      )
    },
    onSearch(val) {
      this.questionList = []
      this.questionInfo = val
      this.getQuestions()
    },
    selecttype(e) {
      this.questionList = []
      this.questionTypeValue = e.target.defaultValue
      this.getQuestions()
    },
    selectlevel(e) {
      this.questionList = []
      this.questionLevelValue = e.target.defaultValue
      this.getQuestions()
    },
    getQuestions() {
      getQuestions({
        iCourseId: this.courseid,
        iQuestionType: this.questionTypeValue,
        iQuestionLevel: this.questionLevelValue,
        strQuestionInfo: this.questionInfo,
      }).then((response) => {
        if (response.data.iCode == 0) {
          this.questionList = response.data.objData
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    allCheck(val) {
      var a = -1
      this.selectedtopic.map((item, index) => {
        if (item.question.iQuestionId == val.question.iQuestionId) {
          a = index
        }
      })
      if (a == -1) {
        this.selectedtopic.push(val)
      } else {
        this.selectedtopic.splice(a, 1)
      }
    },
    back() {
      this.$router.go(-1)
      this.$parent.getexamination()
    },
    savework() {
      this.itiScore = 1
      this.selectedtopic.map((item) => {
        if (item.iScore == 0) {
          this.itiScore = item.iScore
        }
      })
      if (this.$route.query.examinationType == '1') {
        if (this.selectedtopic.length == 0) {
          return this.$message.error(this.$t('translateText.newwork.zytmbwk'))
        }
        if (this.topic == '' || this.topic.split(' ').join('').length == 0) {
          return this.$message.error(this.$t('translateText.newwork.zymcbwk'))
        }
        if (this.itiScore == 0) {
          return this.$message.error(this.$t('translateText.newwork.cztmw'))
        }
      } else {
        if (this.selectedtopic.length == 0) {
          return this.$message.error(this.$t('translateText.newwork.kstmbwk'))
        }
        if (this.topic == '' || this.topic.split(' ').join('').length == 0) {
          return this.$message.error(this.$t('translateText.newwork.ksmcbwk'))
        }
        if (this.itiScore == 0) {
          return this.$message.error(this.$t('translateText.newwork.cztmfs'))
        }
      }
      this.selectUserDiv = true
      this.getcompiledata = JSON.parse(sessionStorage.getItem('compiledata'))
      this.$nextTick(() => {
        this.$refs.selectuser.startValue = moment(this.getcompiledata.StartTime) //开始时间
        this.$refs.selectuser.endValue = moment(this.getcompiledata.EndTime) //结束时间
        this.$refs.selectuser.passingScore = this.getcompiledata.iPassingScore //及格分数线
        this.$refs.selectuser.goodScore = this.getcompiledata.iGoodScore //良好分数线
        this.$refs.selectuser.excellentScore = this.getcompiledata.iExcellentScore //优秀分数线
        this.$refs.selectuser.isStickUp =
          this.getcompiledata.IsStickUp == 1 ? true : false //是否允许粘贴
        this.$refs.selectuser.isOutOrder =
          this.getcompiledata.IsOutOrder == 1 ? true : false //是否乱序
        this.$refs.selectuser.isViewScore =
          this.getcompiledata.IsViewScore == 1 ? true : false //学生是否可看成绩
      })

      getExaminationReceiveList({
        iExamReleaseId: this.getcompiledata.iExamReleaseId,
        strUserName: '',
      }).then((response) => {
        this.Receiveinfo = response.data.objData
        if (this.getcompiledata.iNumber == 0) {
          response.data.objData.map((item) => {
            this.ReceiveclassList.push(item.user.userClass.iClassId)
          })
          this.$refs.selectuser.checkclass(this.ReceiveclassList)
          this.$nextTick(() => {
            this.$refs.selectuser.issueTypeValue = 0
            this.$refs.selectuser.showClassList = true
            this.$refs.selectuser.showUserList = false
            this.$refs.selectuser.getstudent()
          })
          this.releaseobj = this.ReceiveclassList.map((item) => {
            return Object.assign({}, { iClassId: item })
          })
          this.releaseobj = this.unique(this.releaseobj)
        }
        if (this.getcompiledata.iNumber == 1) {
          response.data.objData.map((item) => {
            this.ReceiveList.push(item.user.iUserId)
          })
          this.$refs.selectuser.checkuser(this.ReceiveList)
          this.$nextTick(() => {
            this.$refs.selectuser.issueTypeValue = 1
            this.$refs.selectuser.showClassList = false
            this.$refs.selectuser.showUserList = true
            this.$refs.selectuser.getstudent()
          })
          this.releaseobj = this.ReceiveList.map((item) => {
            return Object.assign({}, { iUserId: item })
          })
        }
        this.$refs.selectuser.iseliminate = false
        this.ReceiveList = []
        this.ReceiveclassList = []
      })
    },
    cancelButton() {
      this.selectUserDiv = false
      this.selectUserBtn = false
    },
    //数组去重
    unique(arr) {
      const res = new Map()
      return arr.filter(
        (arr) => !res.has(arr.iClassId) && res.set(arr.iClassId, 1)
      )
    },
    //获取试卷发布设置
    getExaminationRelease(examinationRelease) {
      this.examinationRelease = examinationRelease
    },
    //获取选中的用户或班级
    getReceiveList(val, type) {
      this.releasetype = type
      if (type == 0) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iClassId: item })
        })
      } else if (type == 1) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iUserId: item })
        })
      }
    },
    okButton() {
      this.grade = 0
      this.getcompiledata = JSON.parse(sessionStorage.getItem('compiledata'))
      this.selectedtopic.map((item) => {
        this.grade += parseInt(item.iScore)
      })

      for (let i = 0; i < this.primary.length; i++) {
        for (let j = 0; j < this.selectedtopic.length; j++) {
          if (
            this.primary[i].question.iQuestionId ==
            this.selectedtopic[j].question.iQuestionId
          ) {
            this.repetitive.push(this.primary[i])
          }
        }
      }
      this.reduced = this.primary.filter(
        (item) => !this.repetitive.includes(item)
      )
      if (this.topic == '' || this.topic.split(' ').join('').length == 0) {
        return this.$message.error(this.$t('translateText.newwork.mcbwk'))
      } else if (this.grade > 100) {
        this.grade = 0
        return this.$message.error(this.$t('translateText.newwork.fsdy'))
      } else {
        updateExamination({
          iExaminationId: this.getcompiledata.iExaminationId,
          strExaminationName: this.topic,
          listExaminationQuestion: this.selectedtopic,
          listDelExaminationQuestion: this.reduced,
        }).then((response) => {
          if (response.data.iCode == 0) {
            this.$parent.data.map((item) => {
              if (item.iExaminationId == this.getcompiledata.iExaminationId) {
                item.strExaminationName = this.topic
              }
            })
            this.$parent.getexamination()
            return this.$message.success(this.$t('translateText.newwork.xgcg'))
          } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      }

      (this.starttime = sessionStorage.getItem('startValuee')), //开始时间
        (this.endtime = sessionStorage.getItem('endValuee')), //结束时间
        (this.passingscore = this.$refs.selectuser.passingScore), //及格分数线
        (this.goodscore = this.$refs.selectuser.goodScore), //良好分数线
        (this.excellentscore = this.$refs.selectuser.excellentScore), //优秀分数线
        (this.stickup = this.$refs.selectuser.isStickUp ? 1 : 0), //是否允许粘贴
        (this.outorder = this.$refs.selectuser.isOutOrder ? 1 : 0), //是否乱序
        (this.viewscore = this.$refs.selectuser.isViewScore ? 1 : 0) //学生是否可看成绩
      this.release = this.$refs.selectuser.showClassList
      this.releasetype = this.$refs.selectuser.issueTypeValue
      if (this.releasetype == 0) {
        this.releasetype = this.$refs.selectuser.issueTypeValue
        updateExaminationRelease({
          iExamReleaseId: this.getcompiledata.iExamReleaseId,
          dtStartTime: moment(this.starttime).format('YYYY-MM-DD HH:mm:ss'),
          dtEndTime: moment(this.endtime).format('YYYY-MM-DD HH:mm:ss'),
          iPassingScore: this.passingscore,
          iGoodScore: this.goodscore,
          iExcellentScore: this.excellentscore,
          isStickUp: this.stickup,
          isOutOrder: this.outorder,
          isViewScore: this.viewscore,
          iExamReleaseType: this.releasetype,
          listUserClass: this.releaseobj,
        }).then((response) => {
          if (response.data.iCode == 0) {
            this.$EventBus.$emit('updateExamina')
          } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      }
      if (this.releasetype == 1) {
        updateExaminationRelease({
          iExamReleaseId: this.getcompiledata.iExamReleaseId,
          dtStartTime: moment(this.starttime).format('YYYY-MM-DD HH:mm:ss'),
          dtEndTime: moment(this.endtime).format('YYYY-MM-DD HH:mm:ss'),
          iPassingScore: this.passingscore,
          iGoodScore: this.goodscore,
          iExcellentScore: this.excellentscore,
          isStickUp: this.stickup,
          isOutOrder: this.outorder,
          isViewScore: this.viewscore,
          iExamReleaseType: this.releasetype,
          listUser: this.releaseobj,
        }).then((response) => {
          if (response.data.iCode == 0) {
            this.$EventBus.$emit('updateExamina')
          } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      }
      this.$router.go(-1)
    },
    handleCancel() {
      this.selectUserDiv = false
      this.selectUserBtn = false
    },
    selectedUserList(val, type) {
      this.releasetype = type
      if (type == 0) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iClassId: item })
        })
      } else if (type == 1) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iUserId: item })
        })
      }
    },
    preview(){
      sessionStorage.setItem('AnswerList', JSON.stringify(this.selectedtopic))
      if (this.$route.path == '/courseContent/Task/Choosework') {
        this.$router.push('/courseContent/Task/Choosework/preview')
      }
      if (this.$route.path == '/courseContent/Exam/Choosework') {
        this.$router.push('/courseContent/Exam/Choosework/preview')
      }
      this.showrouter = true
    }
  },
  components: {
    search,
    selectUser,
    single,
    multiple,
    judgment,
    fillBlank,
    shortAnswer,
    experiment,
  },
  computed: {
    ClassListColumns() {
      return [
        {
          title: this.$t('translateText.newwork.bj'),
          dataIndex: 'strClassName',
        },
      ]
    },
    UserListColumns() {
      return [
        {
          title: this.$t('translateText.newwork.xh'),
          dataIndex: 'strUserName',
        },
        {
          title: this.$t('translateText.newwork.xm'),
          dataIndex: 'strRealName',
        },
      ]
    },
  },
}
</script>

<style lang="stylus" scoped>
input {
  outline: none;
}

.addExamination {
  height: 100%;
  width: 100%;
}

.checkAllBoxDiv {
  position: absolute;
  top: 60px;
  line-height: 40px;
  right: 10%;
}
&/deep/.ant-checkbox-inner {
  border: 2px solid #2EADB5;
}

&/deep/.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #2EADB5;
}

&/deep/.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #2EADB5;
  border-color: #2EADB5;
}

.nameDiv, .questionTypeDiv, .questionLevelDiv {
  color: #2EADB5;
  line-height: 40px;
}

.nameDiv {
  width: 100%;
  display: flex;
  line-height: 60px;
  position: absolute;
  top: 0;
}

.questionTypeDiv {
  position: absolute;
  top: 60px;
}

.questionLevelDiv {
  position: absolute;
  top: 100px;
}

.nameDiv input {
  width: 250px;
  height: 36px;
  border: 1px solid #505050;
  border-radius: 4px;
  padding: 5px;
}

.searchh {
  width: 20%;
  position: absolute;
  top: 20%;
  right: 10%;
}

.nameDiv span, .questionTypeDiv span, .questionLevelDiv span {
  margin-right: 20px;
}

&/deep/.ant-radio-checked .ant-radio-inner {
  border-color: #2EADB5;
}

&/deep/.ant-radio-inner::after {
  background-color: #2EADB5;
}

.questionListDiv {
  position: absolute;
  top: 140px;
  bottom: 60px;
  right: 2%;
  left: 2%;
  overflow: auto;
}

.btnDiv {
  position: absolute;
  bottom: -5px;
  right: 2%;
  left: 2%;
  height: 40px;

  // text-align: center
  & button {
    margin-left: 25%;
  }
}

.addHomeWorkDivFooter {
  text-align: center;
  margin-top: 10px;
}

.addHomeWorkDivFooter button {
  margin: 0 20px;
  padding: 5px 15px;
  background-color: #fff;
  border: solid 1px #7C838D;
  border-radius: 3px;
  color: #7C838D;
}

.addHomeWorkDivFooter .okButton {
  background-color: #2EADB5;
  border: none;
  color: #fff;
}
.notdata{

  margin-top: 18%;
  margin-left: 36%;
  width :200px
}
.notdatas{
  margin-top :1%;
  margin-left: 43%;
  color :rgba(0, 0, 0, 0.35);
}
/deep/span.ant-radio + * {
    padding-right: 3px;
    padding-left: 3px;
}
</style>
